const pickRequestField = (request, camelKey, snakeKey, defaultValue) => {
  if (request[camelKey] != null) {
    return request[camelKey]
  }
  if (request[snakeKey] != null) {
    return request[snakeKey]
  }
  return defaultValue !== undefined ? defaultValue : null
}

const normalizeQueueRequest = (request) => ({
  ...request,
  id: request.id != null ? parseInt(request.id) : request.id,
  estimatedAcceptTime: pickRequestField(request, 'estimatedAcceptTime', 'estimated_accept_time'),
  predictedAcceptedBy: pickRequestField(request, 'predictedAcceptedBy', 'predicted_accepted_by'),
  predictedAcceptedByNickname: pickRequestField(request, 'predictedAcceptedByNickname', 'predicted_accepted_by_nickname'),
})

const SET_REQUESTS = (state, payload) => {
  state.requests = Array.isArray(payload)
    ? payload.map((request) => normalizeQueueRequest(request))
    : payload
}

const normalizeActiveRequest = (request) => {
  if (!request) {
    return null
  }

  return {
    ...request,
    id: request.id != null ? parseInt(request.id) : request.id,
    startedAt: pickRequestField(request, 'startedAt', 'started_at'),
    endedAt: pickRequestField(request, 'endedAt', 'ended_at'),
    callEndedAt: pickRequestField(request, 'callEndedAt', 'call_ended_at'),
    dispenserEndedAt: pickRequestField(request, 'dispenserEndedAt', 'dispenser_ended_at'),
    audiologistEndedAt: pickRequestField(request, 'audiologistEndedAt', 'audiologist_ended_at'),
    acceptedBy: pickRequestField(request, 'acceptedBy', 'accepted_by'),
    estimatedDuration: pickRequestField(request, 'estimatedDuration', 'estimated_duration'),
    customerName: pickRequestField(request, 'customerName', 'customer_name'),
    customerNumber: pickRequestField(request, 'customerNumber', 'customer_number'),
    dispenserNickname: pickRequestField(request, 'dispenserNickname', 'dispenser_nickname'),
    createdAt: pickRequestField(request, 'createdAt', 'created_at'),
    dailyRequestNr: pickRequestField(request, 'dailyRequestNr', 'daily_request_nr'),
  }
}

const SET_ACTIVE_REQUEST = (state, { request }) => {
  state.activeRequest = normalizeActiveRequest(request)
}

const SET_ONLINE_AUDIOLOGISTS = (state, payload) => {
  state.onlineAudiologists = payload
  state.activeBreak = payload.selfBreak
}

const HANDLE_MINIMIZED_CALL_COLLAPSED = (state) => {
  state.minimizedCallCollapsed = !state.minimizedCallCollapsed
}

const SET_ACTIVE_BREAK = (state, { _break }) => {
  state.activeBreak = _break
}

const RESET_ACTIVE_BREAK = (state) => {
  state.activeBreak = null
}

const RESET_ACTIVE_REQUEST = (state) => {state.activeRequest = null}

const UPDATE_METRICS = (state, {metrics}) => {
  state.metrics = {...metrics}
}

export default {
  SET_REQUESTS,
  SET_ONLINE_AUDIOLOGISTS,
  HANDLE_MINIMIZED_CALL_COLLAPSED,
  SET_ACTIVE_BREAK,
  RESET_ACTIVE_BREAK,
  SET_ACTIVE_REQUEST,
  RESET_ACTIVE_REQUEST,
  UPDATE_METRICS
}
